import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { RESTORE_STATUS } from '../../../constants/RestoreStatus';

class ModalManageContentInfoRow extends Component {
    render() {
        return (
            <tr colSpan="3">
                <td>
                    <time style={{ marginRight: '10px' }}>
                        {moment.utc(this.props.updatedTime).format('MM/DD/YYYY HH:mm')}
                    </time>
                    <br />
                    {this.props.showViewDetails && (
                        <a onClick={this.props.showDetails}>
                            {`View details`}
                            <i className="spark-icon spark-icon--fill spark-icon-arrow-triangle-right" />
                        </a>
                    )}
                </td>
                <td>{this.props.userName}</td>
                <td>{this.props.comment}</td>
                <td>
                    {this.props.showRestore === RESTORE_STATUS.CURRENT ? (
                        <p>Current Version</p>
                    ) : this.props.showRestore === RESTORE_STATUS.RESTORE ? (
                        <a onClick={this.props.restoreElem}>RESTORE</a>
                    ) : (
                        <a disabled>RESTORE</a>
                    )}
                </td>
            </tr>
        );
    }
}

ModalManageContentInfoRow.propTypes = {
    showViewDetails: PropTypes.bool,
    userName: PropTypes.string.isRequired,
    comment: PropTypes.string,
    updatedTime: PropTypes.number.isRequired,
    index: PropTypes.number,
    showDetails: PropTypes.func,
    restoreElem: PropTypes.func,
    showRestore: PropTypes.string
};

ModalManageContentInfoRow.defaultProps = {
    showViewDetails: false
};

export default ModalManageContentInfoRow;



// WEBPACK FOOTER //
// ./src/components/modals/modalContent/ModalManageContentInfoRow.js